<div class="avatar"
     [style.width.px]="px"
     [style.height.px]="px"
     [attr.aria-label]="ariaLabel"
     role="img"
     (click)="onAvatarClick()">
  <ng-container *ngIf="miniUrl as url; else fallback">
    <img class="avatarImg"
         [attr.alt]="ariaLabel"
         loading="lazy"
         [src]="url">
  </ng-container>
  <ng-template #fallback>
    <img class="avatarImg avatarFallback"
         [attr.alt]="ariaLabel"
         loading="lazy"
         [src]="fallbackSrc">
  </ng-template>
</div>
